import { create } from 'zustand';
import { pointsInPolygon, type Vertex } from '../lib/pointInPolygon';

export type SelectionMode = 'idle' | 'drawing' | 'selected';

type SelectionState = {
  mode: SelectionMode;
  polygon: Vertex[];
  baseSelection: Uint32Array | null;
  startDrawing: () => void;
  addVertex: (v: Vertex) => void;
  closePolygon: (positions: Float32Array) => void;
  clearSelection: () => void;
};

export const useSelectionStore = create<SelectionState>((set) => ({
  mode: 'idle',
  polygon: [],
  baseSelection: null,
  startDrawing: () =>
    set({ mode: 'drawing', polygon: [], baseSelection: null }),
  addVertex: (v) =>
    set((s) => (s.mode === 'drawing' ? { polygon: [...s.polygon, v] } : s)),
  closePolygon: (positions) =>
    set((s) => {
      if (s.mode !== 'drawing' || s.polygon.length < 3) return s;
      const indices = pointsInPolygon(positions, s.polygon);
      return { mode: 'selected', baseSelection: indices };
    }),
  clearSelection: () =>
    set({ mode: 'idle', polygon: [], baseSelection: null }),
}));
